import { graphql } from '@e-socna/data-layer';

import { useGraphQLMutation } from '../../../hooks/useGraphQLMutation.hook';

export const ResolvableMissionTypeForm_ServiceUsage_Create_Mutation = graphql(`
  mutation ResolvableMissionTypeForm_ServiceUsage_Create(
    $serviceUsage: ResolvableServiceUsageInput!
    $serviceUserId: Id!
    $serviceUsagesGroupId: Id!
    $versionData: VersionDataInput
  ) {
    createResolvableMissionTypeServiceUsage(
      serviceUsage: $serviceUsage
      serviceUserId: $serviceUserId
      serviceUsagesGroupId: $serviceUsagesGroupId
      versionData: $versionData
    ) {
      _id
    }
  }
`);

export const useCreateMissionServiceUsageMutation = () =>
  useGraphQLMutation(ResolvableMissionTypeForm_ServiceUsage_Create_Mutation);
